import React from 'react';
import TelecomsHero from '../components/telecoms/TelecomsHero';
import TelecomsContext from '../components/telecoms/TelecomsContext';
import TelecomsSolution from '../components/telecoms/TelecomsSolution';
import TelecomsCapabilities from '../components/telecoms/TelecomsCapabilities';
import TelecomsValue from '../components/telecoms/TelecomsValue';
import TelecomsIndustryMovement from '../components/telecoms/TelecomsIndustryMovement';
import SEO from '../components/SEO';
const Telecoms = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-618">
      <SEO title="Voxie AI for Telecoms - AI on SMS for Every Subscriber" description="Enable generative AI for all subscribers through SMS, USSD, and voice. Drive new revenue streams and digital inclusion with AI accessible to everyone." canonicalUrl="https://voxie.ai/telecoms" data-id="element-619" />
      <TelecomsHero data-id="element-620" />
      <TelecomsContext data-id="element-621" />
      <TelecomsSolution data-id="element-622" />
      <TelecomsCapabilities data-id="element-623" />
      <TelecomsValue data-id="element-624" />
      <TelecomsIndustryMovement data-id="element-625" />
    </div>;
};
export default Telecoms;